import { Brand } from './typings'

const sams: Brand = {
  clientInfo: {
    displayName: "Sam's Club",
    accountNumberLengths: [16, 19],
    footerDisplay: 'SamsClub.com',
    footerLink: 'https://www.samsclub.com/',
    applicationUrl:
      'https://www.samsclub.com/sams/pagedetails/content.jsp?pageName=credit&tab=personal',
    dsecApigeeClientId: {
      development: 'uVB3oTOY1WA8612EH8TmAsTein83HrAi',
      production: 'ifS11gSAo0BrekolOI3TANSoWHTvzjtA'
    },
    setpayApigeeClientId: {
      development: 'YUldHBUBka4DrAUylcGg4Bse2EcTFoh6',
      production: 'YUldHBUBka4DrAUylcGg4Bse2EcTFoh6' // has to be changed in future
    },
    metaTagCardTitle: {
      en: 'Credit Card',
      es: 'Tarjeta de Crédito'
    },
    metaTagCardDescription: {
      en: `Log into your Sam's Club credit card account online to pay your bills, check your FICO score, sign up for paperless billing, and manage your account preferences`,
      es: `Ingrese a su cuenta de la Tarjeta de Crédito Sam's Club en línea para pagar sus facturas, revisar su puntuación FICO, inscribirse en facturas digitales y manejar su cuenta.`
    },
    persistApigeeClientId: {
      development: 'dkKSfRC21GTOhKGQv0Lwnnrew7WdM7Au',
      production: 'kwK2V8YgQxNx1wihFqctpFmvDofFvG2H'
    },
    languages: ['en'],
    vanityUrl: 'SamsClub.com',
    hostname: 'samsclub.syf.com',
    linkingRedirect: '',
    ivaKey: '4a5d29e4-81ed-42ff-82a0-45675f76e272',
    hasMss: true,
    hasCpl: true,
    promoUrl: '',
    hasCplOldErrorCode: false,
    isMultiAccount: false,
    footerContent: {
      en: "Sam's Club® Mastercard® or Sam's Club® Credit Card is issued by Synchrony Bank. The Synchrony Bank Privacy Policy governs the use of the Sam's Club Mastercard or Sam's Club Credit Card. The use of this site is governed by the use of the Synchrony Bank Internet Privacy Policy, which is different from the privacy policy of Sam's Club. The content and documents displayed may not all be provided in Spanish.",
      es: "Synchrony Bank emite su tarjeta de crédito Sam's Club® Mastercard® o Sam's Club®. La Política de privacidad de Synchrony Bank rige el uso de Sam's Club® Mastercard® o Sam's Club® Credit Card. El uso de este sitio se rige por el uso de la Política de privacidad de Internet de Synchrony Bank, que es diferente de la política de privacidad de Sam's Club®. Es posible que el contenido y los documentos que se muestran pueden no se proporcionen en español."
    },
    phoneNumbers: {
      loan: '1-844-397-6504',
      dualcard: '1-866-220-0254',
      plcc: '1-800-964-1917',
      fraud: '1-866-220-0254',
      customerService: '1-800-417-8321'
    },
    iOSAppId: '382497397',
    androidApp: {
      id: 'com.rfi.sams.android',
      author: "Sam's Club",
      title: "Sam's Club",
      image:
        'https://images.synchronycredit.com/mservicegen5secure/generic/sams/img/hres/digitalCardAppIcon.png'
    },
    crossBorder: false,
    cplHeroBannerDisplayName: '',
    termsOfService: {
      en: '/essimages/cs/groups/ess_webasset/generic/@sams/en/html/ess005005.html',
      es: ''
    },
    onlinePrivacy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@sams/en/html/ess004865.html',
      es: ''
    },
    privacyPolicy: {
      en: '/essimages/cs/groups/ess_webasset/generic/@sams/en/html/ess004866.html',
      es: ''
    },
    websiteUsage: {
      en: '/essimages/cs/groups/ess_webasset/generic/@sams/en/html/ess004867.html',
      es: ''
    },
    voice: {
      cardName: "Sam's Club® Credit Card",
      google: {
        termsAndConditionsLink:
          'https://www.synchronycredit.com/CPLTerms/Sams.htm'
      },
      alexa: { termsAndConditionsLink: '' }
    },
    hasDualEnrollment: true
  },
  palette: {
    button: {
      primary: {
        text: '#FFFFFF',
        hover: '#007300'
      },
      secondary: {
        hover: '#cfe5cf'
      },
      background: '#008a00'
    },
    field: {
      icon: '#333333',
      focus: '#34657F',
      label: ''
    },
    progressStepBar: {
      fill: '#333333',
      label: '#333333'
    },
    progressBar: {
      complete: '#3e8529',
      error: '#c63527',
      inProgress: '#0072ad',
      background: '#e9eaeb'
    },
    checkbox: {
      background: '#1977d3',
      font: '#FFFFFF'
    },
    switch: { background: '' },
    heroBackground: '',
    bodyBackground: '#FFFFFF',
    iconBackground: '#e3e3e3',
    headerBackground: '#FFFFFF',
    modalBackground: '#F9F9F9',
    formBackground: '#f2f2f2',
    headerDivider: '#dddddd',
    footerDivider: '#f6f5f6',
    contrastingText: '#f6f5f6',
    bodyText: '#333333',
    languageSelector: '#FFFFFF',
    focus: '#1977d3',
    link: '#1977d3',
    footer: {
      background: '#f2f2f2',
      text: '#6a6a6a',
      link: '#6a6a6a'
    }
  },
  images: {
    logo: {
      en: '/assets/sams/logo.svg',
      es: '/assets/sams/logo.svg'
    },
    hero: '',
    heroBgDesktop: '',
    heroBgMobile: '',
    mainPromo: {
      en: '/assets/sams/promo.png',
      es: '/assets/sams/promo.png'
    },
    voiceCplLogo: '/assets/sams/voicecard.png'
  }
}

export default sams
